/* RESPONSIBLE TEAM: team-integration-apps */
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';

export default class ZendeskIndex extends SettingsRoute {}
